import { createBrowserHistory } from "history";

//API CALL TYPE
//const TYPE_LOCAL = "LOCAL";
const TYPE_REST = "REST";
//console.log(77, process.env.NODE_ENV);

//resources
// const API_URL =
//   process.env.NODE_ENV === "production" ? "" : "https://dev.senshost.net/api";
//const API_URL = "http://senshost.com:8015/api";
const SOCKET_URL = "mqtt://senshost.com";
//API contexts
//We will pass this to swagger class constractor if we need different base urls
//const DEFAULT = "";
//const SECONDARY = "/something";

export enum APILIST {
  LINKS = "links",
  REGISTER = "register",
  HOSTELS = "hostels",
  GET_HOSTEL = "get-hostel",
  GET_ALL_HOSTEL = "get-all-hostel",
  GET_ALL_USERS = "get-all-users"
}

//CONFIG DATA (Please change here only)
const configs = {
  delay: 500,
  dashbordRefreshRate: 1,
  port: 8015,
  appName: "senhost",
  apiGatewayAdminToken: 'se11uYiEW6h2SiC1RRmamSe2B7prg8kz5Nob2vBa6M90192vYc2PudcZoUlrT5VE',
  apiGatewayCronSecret: 'W7icfhSiN6hVx6vpYp0Q3lJBOCqMPTuCdRIEPu2pHCIS3xOSHLrzlxMMq2qtqJKy',
  toastDelay: 5000,
  tokenStorage: "TOKEN_PERSIST",
  socket: SOCKET_URL,
  type: TYPE_REST,

  imageUrl: "https://hammerhead-app-gwbte.ondigitalocean.app/TieredImages/",
  context: "https://hammerhead-app-gwbte.ondigitalocean.app/api",
  baseRedirectFront: 'hammerhead-app-gwbte.ondigitalocean.app/',
  baseRedirect: 'https://hammerhead-app-gwbte.ondigitalocean.app',




  // imageUrl: "http://127.0.0.1:8000/TieredImages/",
  // context: "http://127.0.0.1:8000/api",
  // baseRedirectFront: 'http://localhost:3000/',
  // baseRedirect: 'http://127.0.0.1:8000',

  history: createBrowserHistory(),
  requestTimeOut: 3000000,
  apiList: APILIST,
  tablePageSize: 10,
};
export default configs;
